import { menuItemState } from '../utils/adminAccess.mjs';

const navigationGroups = [
  {
    key: 'diagnostic-tools',
    label: '诊断工具',
    items: [
      { index: 1, label: '在线诊断日志', iconKey: 'tickets', name: 'DataDisplay', colorClass: 'blue' },
      { index: 3, label: '测试接头', iconKey: 'avatar', name: 'TestSn', colorClass: 'blue' },
      { index: 4, label: '接头配置', iconKey: 'key', name: 'SnMycarInfo', colorClass: 'blue' },
      { index: 9, label: '下载与维护', iconKey: 'download', name: 'FileDownload', colorClass: 'indigo' },
    ],
  },
  {
    key: 'system-config',
    label: '系统配置',
    items: [
      { index: 2, label: 'Ford 配置', iconKey: 'setting', name: 'FordConfig', colorClass: 'teal' },
    ],
  },
  {
    key: 'data',
    label: '数据',
    items: [
      { index: 10, label: 'Deliver 查询', iconKey: 'operation', name: 'DeliverFunction', colorClass: 'blue' },
      { index: 6, label: 'VIN 数据', iconKey: 'star', name: 'VinList', colorClass: 'sky' },
      { index: 8, label: '防盗 VIN 数据', iconKey: 'collectionTag', name: 'VinIMMO', colorClass: 'sky' },
      { index: 13, label: '多产品', iconKey: 'notebook', name: 'ProductGuide', colorClass: 'blue' },
      { index: 7, label: '数据转存', iconKey: 'connection', name: 'DataSwitch', colorClass: 'cyan', option: 'showDataSwitchMenu' },
    ],
  },
  {
    key: 'risk-control',
    label: '风控',
    items: [
      { index: 5, label: '黑名单', iconKey: 'lock', name: 'BlackSn', colorClass: 'coral' },
    ],
  },
  {
    key: 'brand-tools',
    label: '品牌综合',
    items: [
      { index: 11, label: '马自达综合', iconKey: 'suitcase', name: 'Mazda', colorClass: 'purple' },
      { index: 12, label: 'SGM 综合菜单', iconKey: 'operation', name: 'SgmMenu', colorClass: 'cyan' },
    ],
  },
];

export function buildNavigationGroups(userData, options = {}) {
  return navigationGroups
    .map((group) => ({
      ...group,
      items: group.items
        .filter((item) => !item.option || options[item.option] === true)
        .map((item) => ({
          ...item,
          state: menuItemState(userData, item.name),
        }))
        .filter((item) => item.state !== 'hidden'),
    }))
    .filter((group) => group.items.length > 0);
}
